import { getPathString } from '@helpers'
import { TIME_LINE_GROUP_PREFIX } from '@constants'
import {
  MainObjectTypeEnum,
  ObjectDataRecord,
  TimeLineDTOType,
  TimeLineGridDataRecord,
} from '@types'

import { EmbeddedObject } from '@gantt/components/GanttCreateOrEdit'

import { DateInterval, groupByTimeIntervals, groupObjectXListByObjectYElement } from '../'

import { groupDataByField } from './groupDataByField'

export const groupDataByMainObject = (data: {
  objectXData: ObjectDataRecord[]
  objectYData: ObjectDataRecord[]
  config: TimeLineDTOType
  dateIntervals: DateInterval[]
}) => {
  const { objectXData, objectYData, config, dateIntervals } = data

  // Формируем группы в зависимости от выбранного в конфигураторе объекта
  const groups = groupDataByField({
    groupField: config.mainObject?.groupField as EmbeddedObject[],
    objectData: config.mainObject?.objectType === MainObjectTypeEnum.X ? objectXData : objectYData,
  })

  const result: Record<
    string,
    {
      meta: ObjectDataRecord
      groupedDataByTimeIntervals: TimeLineGridDataRecord[]
    }
  > = {}

  // Группируем данные внутри каждой группы по объекту Y
  groups.forEach((item, key) => {
    const groupedData = groupObjectXListByObjectYElement(
      config,
      config.mainObject.objectType === MainObjectTypeEnum.X ? objectYData : item.data,
      config.mainObject.objectType === MainObjectTypeEnum.X
        ? (item.data as ObjectDataRecord[])
        : objectXData
    )

    // Удаляем записи у котрых нет значений в массиве X, если формируем значения по X
    const updatedGroupData =
      config.mainObject.objectType === MainObjectTypeEnum.X
        ? groupedData.filter(item => item.xArray?.length)
        : groupedData

    const groupedDataByTimeIntervals = groupByTimeIntervals(
      updatedGroupData,
      dateIntervals,
      config.objectX.startDateField,
      getPathString(config.objectY.keyField),
      `${TIME_LINE_GROUP_PREFIX}${key}`
    )

    result[key] = { groupedDataByTimeIntervals, meta: item.meta }
  })

  const rows: TimeLineGridDataRecord[] = []

  Object.keys(result).forEach(key => {
    if (result[key].groupedDataByTimeIntervals.length) {
      rows.push({
        id: `${TIME_LINE_GROUP_PREFIX}${key}`,
        yElement: {},
        value: {
          groupKey: key,
          groupData: result[key].groupedDataByTimeIntervals,
          groupMeta: result[key].meta,
        },
      })
    }

    rows.push(...result[key].groupedDataByTimeIntervals)
  })

  return rows
}
